export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "fr": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Conversation Intercom"])},
        "load_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Charger plus de messages"])},
        "view_in_intercom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Voir dans Intercom"])},
        "show_notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Afficher les notes internes"])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impossible de charger la conversation"])}
      },
      "en": {
        "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Intercom Conversation"])},
        "load_more": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Load more messages"])},
        "view_in_intercom": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View in Intercom"])},
        "show_notes": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Show internal notes"])},
        "error": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Unable to load conversation"])}
      }
    }
  })
}
